"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = require("invariant");

var _invariant2 = _interopRequireDefault(_invariant);

var _RouterContext = require("./RouterContext");

var _RouterContext2 = _interopRequireDefault(_RouterContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */
var InnerPrompt = function (_React$Component) {
  _inherits(InnerPrompt, _React$Component);

  function InnerPrompt() {
    _classCallCheck(this, InnerPrompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  InnerPrompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.props.router.history.block(message);
  };

  InnerPrompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  InnerPrompt.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.props.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  InnerPrompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  InnerPrompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  InnerPrompt.prototype.render = function render() {
    return null;
  };

  return InnerPrompt;
}(_react2.default.Component);

InnerPrompt.propTypes = {
  when: _propTypes2.default.bool,
  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      block: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};
InnerPrompt.defaultProps = {
  when: true
};


var Prompt = function Prompt(props) {
  return _react2.default.createElement(
    _RouterContext2.default.Consumer,
    null,
    function (_ref) {
      var router = _ref.router;
      return _react2.default.createElement(InnerPrompt, _extends({}, props, { router: router }));
    }
  );
};

exports.default = Prompt;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/Prompt.js
 ** module id = 1184
 ** module chunks = 0
 **/